import { render, staticRenderFns } from "./study-planning.vue?vue&type=template&id=b52973a6&scoped=true&"
import script from "./study-planning.vue?vue&type=script&lang=js&"
export * from "./study-planning.vue?vue&type=script&lang=js&"
import style0 from "./study-planning.vue?vue&type=style&index=0&id=b52973a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52973a6",
  null
  
)

export default component.exports